<script lang="ts">
    import type { RichWordlistEntry } from "@app/models/api";
    import { dictionary } from "@app/services/currentDictionary.service";
    import { generatePhraseUrlForCurrentDictionary } from "@app/services/url-builder.service";
    import { annotateFoundFragmentsInSimilarPhrase } from "./annotateFoundFragmentsInPhrase";
    import { fade } from "svelte/transition";

    export let similarPhrasesItem: RichWordlistEntry;
    export let active: boolean = false;
    export let dense: boolean = true;
    export let reverse: boolean = false;
    const containerClass = `block text-gray-800 items-center flex w-full h-full border-b border-slate-100  ${
        dense ? "py-1" : " py-2"
    } transition-all duration-300`;
</script>

<li
    class="similarphrases_item px-3 hover:text-gray-800 transition-all duration-300 w-full hover:bg-slate-100 {active
        ? 'active scrollIntoView'
        : ''}"
    class:bg-slate-100={active}
    dir={$dictionary.l1.rtl ? "rtl" : "ltr"}
>
    <a
        class={containerClass}
        class:underline={active}
        href={generatePhraseUrlForCurrentDictionary(
            similarPhrasesItem.phrase.trim(),
            reverse
        )}
    >
        <div class="flex-1 truncate">
            <div class:dense={$dictionary.l1.dense}>
                {@html annotateFoundFragmentsInSimilarPhrase(
                    similarPhrasesItem
                )}
            </div>
        </div>
        <div
            class="icon_container transition-all duration-300 text-slate-600 block"
        >
            <span class="icon-chevron-right" />
        </div>
    </a>
</li>

<style>
    .similarphrases_item:hover .icon_container {
        display: block !important;
    }
</style>
